var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"x-icon",class:_vm.classes,style:(_vm.styles)},_vm.$listeners),[_vm._t("default",function(){return [(_vm.icon)?_c(_vm.icon,{tag:"component",attrs:{"colors":_vm.colors}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }